export default {
    devices_bulk_pairing_title: "Emparejamiento masivo",
    devices_bulk_pairing_manual: "Manual",
    devices_bulk_pairing_copy_paste: "Copiar y pegar",
    devices_bulk_pairing_vidfleet_esn: "ESN de la cámara",
    devices_bulk_pairing_gps_esn: "GPS ESN",
    devices_bulk_pairing_add: "Agregar",
    devices_bulk_pairing_pair_devices: "Emparejar dispositivos",
    devices_bulk_pairing_label_copy: "Camera ESN (espacio) GPS ESN",
    devices_bulk_pairing_esn_already_added: "El ESN de cámara ya está añadido",
    devices_bulk_pairing_gps_already_added: "El ESN del gps ya está añadido",
    devices_bulk_pairing_message: "Mensaje",
    devices_bulk_pairing_camera_is_invalid: "El ESN de la cámara no es válido",
    devices_bulk_pairing_gps_is_invalid: "El ESN del gps no es válido",
    devices_bulk_pairing_paired: "Emparejado",
    devices_bulk_camera_not_linked_mode: "La cámara NO está en modo emparejado",
    devices_bulk_camera_manufacturer_must_vidfleet_smartwitness: "El fabricante de la cámara debe ser Vidfleet, SmartWitness o LightMetrics",
    devices_bulk_camera_manufacturer_must_diferent_vidfleet_smartwitness: "El fabricante del gps debe ser diferente de Vidfleet, SmartWitness o LightMetrics",
    devices_bulk_same_as_that_of_gps: "El ESN de la cámara no puede ser el mismo que el del gps",
    devices_bulk_is_neces_add_esn_gps: "Es necesario añadir el ESN del gps",
    devices_bulk_error_same_company: "La cámara y el gps deben ser de la misma compañía",

    devices_bulk_cameras_must_be_vidfleet_or_smartWitness: "El fabricante de las cámaras debe ser VidFleet, SmartWitness o LightMetrics",
    devices_bulk_cameras_must_be_in_paired_mode: "Las cámaras deben estar en modo emparejado",
    devices_bulk_devices_must_be_from_the_same_company: "Los dispositivos deben ser de la misma empresa",
    devices_bulk_esn_the_cameras_entered_must_be_valid: "El ESN de las cámaras introducidas debe ser válido",
    devices_bulk_gps_must_be_different_from_vidfleet_or_smartWitness: "El fabricante del gps debe ser diferente de Vidfleet, SmartWitness o LightMetrics",
    devices_bulk_esn_of_cameras: "ESN de las cámaras",
    devices_bulk_number_gps_does_not_match_the_number_of_cameras_entered: "El número de gps no coincide con el número de cámaras introducidas",
    devices_bulk_esn_of_gps: "ESN de los gps",
    devices_bulk_rule_pairing: "Es necesario introducir el esn de los dispositivos en el orden en que van a ser emparejados",
    devices_bulk_there_are_invalid_esn: "Hay esn inválidos",
    devices_bulk_confirm_change_type: "Si continúa y cambia el tipo, se eliminarán las cámaras añadidas anteriormente",
    devices_bulk_gps_vs_cameras_message: "El ESN de los gps no puede ser el mismo que el ESN de las cámaras",
    devices_bulk_pairing_timezone_assign: "Se asignará a la cámara la zona horaria configurada en el dispositivo gps",
    devices_bulk_pairing_transaction_message: "La solicitud para emparejar los dispositivos y cámaras se ha enviado correctamente, por favor revise la lista de transacciones para ver el estado de la solicitud.",
}
